import { useTranslation } from 'react-i18next';
import simulationService from '@/services/simulationService.ts';
import ConfirmDestructiveModal from '@/components/shared/ConfirmDestructiveModal.tsx';

interface Props {
  isOpen: boolean;
  simulation: { id: string; name: string } | null;
  onClose: () => void;
  onDeleted: () => void;
}

export default function DeleteSimulationModal({ isOpen, simulation, onClose, onDeleted }: Props) {
  const { t } = useTranslation();

  if (!simulation) return null;

  const handleConfirm = async () => {
    await simulationService.delete(simulation.id);
    onDeleted();
    onClose();
  };

  return (
    <ConfirmDestructiveModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleConfirm}
      title={t('deleteSimulation.title')}
      description={t('deleteSimulation.confirmMessage', { name: simulation.name })}
      confirmLabel={t('common.delete')}
      confirmingLabel={t('common.deleting')}
      errorFallback={t('deleteSimulation.error')}
    />
  );
}
